import { TransformComponent, TransformWrapper } from 'react-zoom-pan-pinch'

import {
  useRawLayout,

  useLayoutMirrored,
  useLayoutUnrotated,
  useFinialVersion
} from '@routes/MapInvestigator/data'

import type { TransformedLayoutResponse } from '@state/layout/types'

function MapInvestigator() {
  return (
    <div className='flex size-full'>
      <div className='h-1/2 w-1/4 border border-amber-400'>
        <h1>Raw Layout</h1>
        <Raw layout={useRawLayout()} />
      </div>

      <div className='w-1/4 border border-amber-400'>
        <h1>Mirrored Layout</h1>
        <Raw layout={useLayoutMirrored()} />
      </div>

      <div className='w-1/4 border border-amber-400'>
        <h1>Unrotated Layout</h1>
        <Raw layout={useLayoutUnrotated()} />
      </div>

      <div className='h-200 w-1/4 border border-amber-400'>
        <h1>final version</h1>
        <Raw layout={useFinialVersion()} />
      </div>
    </div>
  )
}

interface RawProps {
  layout?: TransformedLayoutResponse
}

function Raw({ layout }: RawProps) {
  if (!layout) return <div>-</div>

  return (
    <TransformWrapper>
      <TransformComponent wrapperClass='size-full!' contentClass='size-full!'>
        <svg
          data-testid="floor:2d"
          xmlns="http://www.w3.org/2000/svg"
          viewBox={`0 0 ${layout.width} ${layout.height}`}
          preserveAspectRatio="xMidYMid meet"
          className=''
        >
          <circle cx="0" cy="0" r="0.8" />

          {layout.shelves.map(shelf => {
            const { x, y, width, depth, rotationDeg } = shelf

            return (
              <rect
                key={`floor:shelf-${shelf.id}`}
                role="button"
                x={x}
                y={y}
                rx={0.1}
                ry={0.1}
                width={width}
                height={depth}
                transform={`rotate(${rotationDeg}, ${x}, ${y})`}
                vectorEffect="non-scaling-stroke"
                style={{ fill: 'red' }}
              />
            )
          })}
        </svg>
      </TransformComponent>
    </TransformWrapper>
  )
}

export default MapInvestigator